import React from "react";
import bootstrap from "../assets/images/bootstrap.svg";
import js from "../assets/images/js.svg";
import firebase from "../assets/images/firebase.svg";
import react from "../assets/images/react.svg";
import sass from "../assets/images/sass.svg";
import figma from "../assets/images/figma.svg";
import typescript from "../assets/images/typescript.svg";
import sanity from "../assets/images/sanity.svg";
import nextjs from "../assets/images/nextjs.svg";

const Tools = () => {
  return (
    <>
      <div className="toolbox-container">
        <h2>My Toolbox</h2>
      </div>
      <div className="toolbox">
        <div className="grid-container">
          <div className="first">
            <img src={firebase} alt="toolbox" />
            <h4>FIREBASE</h4>
          </div>
          <div className="second">
            <img src={sanity} alt="toolbox" />
            <h4>SANITYCDN</h4>
          </div>
          <div className="third">
            <img src={sass} alt="toolbox" />
            <h4>SASS</h4>
          </div>
          <div className="fourth">
            <img src={bootstrap} alt="toolbox" />
            <h4>BOOTSTRAP</h4>
          </div>
          <div className="fifth">
            <img src={react} alt="toolbox" />
            <h4>REACT</h4>
          </div>
          <div className="sixth">
            <img src={figma} alt="toolbox" />
            <h4>FIGMA</h4>
          </div>
          <div className="sixth">
            <img src={typescript} alt="toolbox" />
            <h4>TTYPESCRIPT</h4>
          </div>
          <div className="sixth">
            <img src={nextjs} alt="toolbox" className="fit" />
            <h4>NEXTJS</h4>
          </div>
          <div className="sixth">
            <img src={react} alt="toolbox" />
            <h4>REACT NATIVE</h4>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tools;
